/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Bar from "../../Charts/Bar";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IRecruitmentProcessProps {
  recruitmentProcess: {
    categories: [string];
    min: [number];
    max: [number];
    mean: [number];
  }[];
  recruitmentProcessWidgetLoader: boolean;
}

export class RecruitmentProcess extends Component<any> {
  static propTypes = {
    recruitmentProcess: PropTypes.shape({
      categories: PropTypes.arrayOf(PropTypes.string).isRequired,
      min: PropTypes.arrayOf(PropTypes.number).isRequired,
      mean: PropTypes.arrayOf(PropTypes.number).isRequired,
      max: PropTypes.arrayOf(PropTypes.number).isRequired,
    }),
    recruitmentProcessWidgetLoader: PropTypes.bool.isRequired,
  };

  roundOff = (num: number | null) => {
    if (num === null) return null;
    return Math.round(num * 100) / 100;
  };

  render(): ReactNode {
    const { recruitmentProcess, recruitmentProcessWidgetLoader } = this.props;

    const recruitmentProcessOptions = {
      series: [
        {
          name: "Min",
          data: recruitmentProcess.min.map(this.roundOff),
        },
        {
          name: "Mean",
          data: recruitmentProcess.mean.map(this.roundOff),
        },
        {
          name: "Max",
          data: recruitmentProcess.max.map(this.roundOff),
        },
      ],
      options: {
        height: 350,
        width: 400,
        colors: ["#C62A77", "#673490", "#DE6F35"],
        chart: {
          height: 350,
          type: "bar",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        xaxis: {
          categories: recruitmentProcess.categories,
          title: {
            text: "Stages",
          },
        },
        yaxis: {
          title: {
            text: "No. of Days",
          },
          min: 0,
          max: Math.max(
            ...recruitmentProcess.min,
            ...recruitmentProcess.max,
            ...recruitmentProcess.mean,
            10
          ),
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
      },
    };

    return (
      <Fragment>
        <Wrapper
          className="animated fadeIn delay-5"
          id="recruitment-process-widget"
        >
          <AnalyticsWidgetLoading
            text="Updating..."
            active={recruitmentProcessWidgetLoader}
          />

          <Bar
            graphOptions={recruitmentProcessOptions}
            dataTestId="recruitment-process-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="recruitment-process-title"
            data-tip="Breakdown of time taken for candidates to move through hiring process."
            data-for="recruitment-process-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="recruitment-process-title-tooltip"
              className="tooltip-max-width"
            />
            Recruitment Process
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      recruitmentProcess: {
        categories: [string];
        min: [number];
        max: [number];
        mean: [number];
      }[];
    };
    recruitmentProcessWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  recruitmentProcess:
    state.employerAnalytics.jobPerformanceData.recruitmentProcess,
  recruitmentProcessWidgetLoader:
    state.employerAnalytics.recruitmentProcessWidgetLoader,
});

export default connect(mapStateToProps, {})(RecruitmentProcess);
